/**
 * Универсальная подстановка форм множественного числа (work-026).
 *
 * Опирается на стандартный `Intl.PluralRules` — он сам выбирает категорию
 * (`one`/`few`/`many`/`other`/…) по правилам конкретного языка (CLDR). Это
 * избавляет каждый языковой файл от ручной реализации правил склонения для
 * славянских, арабского и прочих языков со сложными формами.
 *
 * Перевод даёт формы по категориям; в каждой `{n}` заменяется на число.
 * Если нужной категории нет — берётся `other`.
 *
 * Пример (русский):
 *   plural('ru', n, { one: '{n} вопрос', few: '{n} вопроса', many: '{n} вопросов' })
 */
export type PluralForms = Partial<
  Record<ReturnType<Intl.PluralRules['select']>, string>
>;

export function plural(locale: string, n: number, forms: PluralForms): string {
  let category: ReturnType<Intl.PluralRules['select']> = 'other';
  try {
    category = new Intl.PluralRules(locale).select(n);
  } catch {
    // Невалидный код языка — остаёмся на 'other'.
  }
  const template = forms[category] ?? forms.other ?? '';
  return template.replace(/\{n\}/g, String(n));
}
